import * as u from "react";
import { i as b, E as f, x as h, r as g, c as x } from "../createReactComponent-58f9bea8.mjs";
import { n as p } from "../property-9daa16cd.mjs";
import { e as y } from "../query-d94c86d2.mjs";
import { r as v } from "../icon-c572aa57.mjs";
import "../base-e16d29d8.mjs";
import "../class-map-2994e95e.mjs";
const C = b`
  .breadcrumb {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
`;
var E = Object.defineProperty, L = Object.getOwnPropertyDescriptor, d = (s, e, t, a) => {
  for (var l, n = a > 1 ? void 0 : a ? L(e, t) : e, r = s.length - 1; r >= 0; r--)
    (l = s[r]) && (n = (a ? l(e, t, n) : l(n)) || n);
  return a && n && E(e, t, n), n;
}, A = ((s) => (s.COLLAPSED = "collapsed", s.FLUID = "fluid", s))(A || {});
class i extends f {
  constructor() {
    super(...arguments), this.label = "Breadcrumb", this.variant = "collapsed";
  }
  getFluidVariant(e) {
    var t, a;
    if (e.length > 2) {
      const l = e[e.length - 2], n = l.innerHTML, r = document.createElement("div");
      r.setAttribute("part", "fluid"), r.style.display = "inline-flex", r.style.font = "var(--exo-text-label-standard)", r.style.alignItems = "center", r.style.gap = "var(--exo-spacing-2x-small)", r.style.textDecoration = "underline";
      const o = document.createElement("ex-icon");
      o.classList.add("breadcrumb-icon"), o.setAttribute("size", "XS"), o.setAttribute("icon", "Left arrow"), o.style.fontSize = "var(--exo-font-size-medium)", r.appendChild(o), r.insertAdjacentHTML("beforeend", n), l.innerHTML = "", l.appendChild(r);
      const c = (a = (t = l.shadowRoot) == null ? void 0 : t.lastElementChild) == null ? void 0 : a.lastElementChild;
      c == null || c.remove(), e.slice(0, e.length).forEach((m) => {
        m !== l && (m.style.display = "none");
      });
    }
  }
  getCollapsedVariant(e) {
    if (e.length > 2) {
      const t = e.slice(1, -2);
      if (t.length > 2) {
        t.slice(1).forEach((n) => {
          n.style.display = "none";
        });
        const a = t[0], l = a.textContent;
        a.textContent = "...", a.addEventListener("click", (n) => {
          a.textContent === "..." && n.preventDefault(), t.forEach((r) => {
            r.style.display = "inline-flex";
          }), a.textContent = l;
        });
      }
    }
  }
  handleSlotChange() {
    const e = [...this.defaultSlot.assignedElements({ flatten: !0 })];
    e.forEach((t, a) => {
      t.tagName.toLowerCase() === "ex-breadcrumb-item" && (a === e.length - 1 ? t.setAttribute("aria-current", "page") : t.removeAttribute("aria-current"));
    }), this.variant === "fluid" ? this.getFluidVariant(e) : this.getCollapsedVariant(e);
  }
  render() {
    return h`
      <nav part="base" class="breadcrumb" aria-label=${this.label}>
        <slot @slotchange=${this.handleSlotChange}></slot>
      </nav>
    `;
  }
}
i.styles = C, d([y("slot")], i.prototype, "defaultSlot", 2), d([p()], i.prototype, "label", 2), d([p()], i.prototype, "variant", 2);
const S = (s = "") => {
  g("ex-breadcrumb", i, s), v(s);
}, z = x({ tagName: "ex-breadcrumb", elementClass: i, react: u, events: {}, displayName: "ExBreadcrumb", registerWebComponent: S });
export {
  A as BreadcrumbVariant,
  z as ExBreadcrumb,
  S as register
};
